// Full memorial link entry
const FULL_MEMORIAL_URL = 'https://october7memorial.com/memoriam';

export const fullMemorialMemorial = {
  id: 4,
  name: 'Full Memorial',
  category: 'special',
  info: `
# Full October 7th Memorial

Click the button below to view the full memorial:

![iframe](${FULL_MEMORIAL_URL})

Click below to view the full memorial:
[Open Full Memorial](${FULL_MEMORIAL_URL})
`
};

// Re-export the URL for other modules
export { FULL_MEMORIAL_URL };
